import { IsNotEmpty, IsNumberString } from 'class-validator';

export class RouteEntityTypeDTO {
    
    @IsNotEmpty()
    @IsNumberString()
    entity: string;

}
